import { Component, Renderer2 } from "@angular/core";
import * as Sentry from '@sentry/angular';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { CustomersService } from "src/app/features/shared/services/ServiceCatalogEncapsulators/Customers.service";
import { ViewsService } from "src/app/features/shared/services/ServiceCatalogEncapsulators/Views.service";
import { SwalNotificationService } from "src/app/features/shared/services/SwalNotification.service";
import { RoleService } from "../../services/Role.service";
import { ViewDTO } from "src/app/features/shared/models/Views/ViewDTO";
import { CustomerDTO } from "src/app/features/shared/models/Customers/CustomerDTO";
import { PermissionDTO } from "src/app/features/shared/models/Permissions/PermissionDTO";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-roles-add',
  templateUrl: './roles-add.component.html',
  styleUrls: ['./roles-add.component.css']
})
export class RolesAddComponent {

  public formGroup: FormGroup;
  public viewList: ViewDTO[];
  public permissionList: { permission: string, checked: boolean }[] = [];
  public submitData: { Id: string, RoleName: string, ShortName: string, RoleDescription: string, Status:string, ViewsRole: any[] , permissionsRole: any[], ClientId : string};
  public clientes: { id: string, name: string }[] = [];
  vinDirectAssignPermission: PermissionDTO = null;
  hasVinDirectAssignPermission = false;
  readonly: boolean = true;
  _isVinsSelected: boolean;
  _stringIdentifiers: string ="";
  click = false;

  subscription_getInsertRoles: Subscription;
  subscription_getCustomers: Subscription;
  subscription_postInsertUser: Subscription;

  constructor(
    private sessionService: SessionService,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private roleService: RoleService,
    private viewService: ViewsService,
    private notifyService: SwalNotificationService,
    private routerService: Router,
    private customerService: CustomersService
  ) {
    this._isVinsSelected = false;
  }

  ngOnInit(): void {
    this.sessionService.setIsExternalMap(false);
    this.getInsertViews();
    this.getCustomers();
    this.bulidForm();
    this.readonly = true;
  }
  ngOnDestroy() {
    if (this.subscription_getInsertRoles) 
      this.subscription_getInsertRoles.unsubscribe();
    if (this.subscription_postInsertUser) 
      this.subscription_postInsertUser.unsubscribe();
    if (this.subscription_getCustomers) 
      this.subscription_getCustomers.unsubscribe();
  }
  getInsertViews() {
    this.subscription_getInsertRoles = this.viewService.getList().subscribe({
      next: (data) => {
        if (data.isSuccess) {
          this.viewList = data.result as ViewDTO[];
          //para sacar el de asignación de las views
          this.viewList = this.viewList.map(view => {
            const filterAvailablePermissions = view.availablePermissions.filter(permission => {
              if (permission.name.includes("Asigna") && permission.name.includes("VIN")) {
                this.vinDirectAssignPermission = permission;
                this.hasVinDirectAssignPermission = true;
                return false;
              }else{
                return true;
              }
            });
            return { ...view, availablePermissions: filterAvailablePermissions };
          });
          this.viewList.sort((a, b) => a.idOrder - b.idOrder);
          if (this.hasVinDirectAssignPermission) {
            this.formGroup.addControl("vinDirectAssign", this.formBuilder.control(false));
          }
        }else{
          console.error('Error al obtener lista de vistas', data.message, data.result);
          Sentry.captureMessage('RolesAdd.getInsertViews: isSuccess false', { level: 'warning', extra: { response: data } });
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener lista de vistas', error);
      }
    });
  }

  getCustomers() {
    this.subscription_getCustomers = this.customerService.getAll().subscribe({
      next: (data) => {
        if (data.isSuccess) {
          const resp = data.result as CustomerDTO[];
          if(!environment.production) console.log('data',data.result);
          this.clientes = resp.map((x) => {
            return { id: x.clientId, name: x.description };
          });
          if(!environment.production) console.log('clientes',this.clientes);
        }else{
          console.error('Error al obtener clientes', data.message, data.result);
          Sentry.captureMessage('RolesAdd.getCustomers: isSuccess false', { level: 'warning', extra: { response: data } });
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener clientes', error);
      }
    });
  }

  bulidForm() {
    this.formGroup = this.formBuilder.group({
      rolName: ["", Validators.required],
      rolShortName: ["", Validators.required],
      client: [""],
      rolDescription: [""],
      viewList: [[]],
    });
  }

  private buildForm() {
    this.formGroup = this.formBuilder.group({});
  }

  public onSubmit(rol: any) {
    if (rol.rolName != null && typeof (rol.rolName === "string")){
      var client = rol.client == null ? "" : rol.client;
      var checkedViews = this.viewList.filter(x => x.isActive == true);
      var checkedPermission = checkedViews.map(x => x.availablePermissions.filter(y => y.isActive == true)).reduce((accumulator, currentValue) => accumulator.concat(currentValue), []);
      if (this.hasVinDirectAssignPermission && this.vinDirectAssignPermission && rol && rol.vinDirectAssign) {
        this.vinDirectAssignPermission.isActive = rol.vinDirectAssign;
        checkedPermission.push(this.vinDirectAssignPermission);
      }
      this.submitData = { Id: "", RoleName: rol.rolName, ShortName:  rol.rolShortName, RoleDescription: rol.rolDescription, ViewsRole: checkedViews, permissionsRole: checkedPermission, Status: "Activo", ClientId: client};
      
      if(!environment.production) console.log('submitData',this.submitData);
      
      this.subscription_postInsertUser = this.roleService.postInsertRole(this.submitData).subscribe({
        next: (data) => {
          if (data.isSuccess) {
            this.notifyService.MessageSuccessful(
              "Rol Creado Exitosamente",
              "El rol fue creado exitosamente"
            );
            this.routerService.navigate(["/settingsAdmin"]);
          } else {
            this.notifyService.MessageError( data.result );
            console.error('Error al insertar rol', data.message, data.result);
            Sentry.captureMessage('RolesAdd.postInsertRole: isSuccess false', { level: 'warning', extra: { response: data } });
          }
        },
        error: (error) => {
          // TODO marca para complete despues
          console.error('Error al insertar rol', error);
          this.notifyService.MessageError("Error al crear el rol, contacte con el administrador");
        }
      });
    }
    this.submitData = { Id: "", RoleName: "", ShortName:  "", RoleDescription: "", ViewsRole: [] , permissionsRole: [], Status: "", ClientId: ""};
  }

  public getError(controlName: string): string {
    let error = "";
    const control = this.formGroup.get(controlName);
    if (control?.touched && control?.errors != null) {
      if (control?.errors?.["required"]) error = "Campo Requerido *";
      else if (control?.errors?.["email"]) error = "Introduzca un email válido *";
      else if (control?.errors?.["minLength"]) error = "Minimo 8 digitos *";
      else error = JSON.stringify(control.errors);
    }
    return error;
  }

  selectView(view: any){
    view.isActive = !view.isActive;
    view.availablePermissions.forEach(permission => {
      permission.isActive = true;
    });
    if(!environment.production) console.log('help',view.isActive);
  }

}
